export default class UnreachableException {
    constructor(value) {
        return new Error(`unreachable case: ${JSON.stringify(value)}`);
    }
}
